export const environment = {
  production: true,
  backendUrl: window.location.origin,
};
